import { gql } from '@apollo/client';

export const GET_APPS = gql`
    query GetApps {
        apps {
            success
            error
            valorEsperado {
                idApp
                fechaAlta
                descripcion
                archivo
                entrada
                menu
            }
        }
    }
`;
